"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import Image from "next/image";
import { motion } from "framer-motion";
const EASE: [number, number, number, number] = [0.25, 0.1, 0.25, 1];

// Matches the live site's WOW.js `data-wow-delay` values for this 3-card row.
const WOW_DELAYS = [0.2, 0.4, 0.6];
type BusinessModelCardProps = {
  icon: string;
  title: string;
  description: string;
  index?: number;
};
export default function BusinessModelCard(t0) {
  const $ = _c(25);
  const {
    icon,
    title,
    description,
    index: t1
  } = t0;
  const index = t1 === undefined ? 0 : t1;
  const desktopAnimations = useDesktopAnimations();
  const delay = WOW_DELAYS[index] ?? (index % 3 === 0 ? 0.2 : index % 3 === 1 ? 0.4 : 0.6);
  let t2;
  if ($[0] !== desktopAnimations) {
    t2 = desktopAnimations ? {
      opacity: 0,
      y: 40
    } : false;
    $[0] = desktopAnimations;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== desktopAnimations) {
    t3 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[2] = desktopAnimations;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== desktopAnimations) {
    t4 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[4] = desktopAnimations;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      once: true,
      amount: 0
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== delay) {
    t6 = {
      duration: 1,
      delay,
      ease: EASE
    };
    $[7] = delay;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== icon || $[10] !== title) {
    t7 = <div className="flex justify-center"><Image src={icon} alt={title} width={80} height={80} priority={false} className="h-20 w-20 object-contain" /></div>;
    $[9] = icon;
    $[10] = title;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== title) {
    t8 = <h3 className="mt-8 text-xl font-bold text-[#11154b] transition-colors duration-300 dark:text-white">{title}</h3>;
    $[12] = title;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== description) {
    t9 = <p className="mt-4 text-base font-open-sans leading-7 text-[#7782a6] transition-colors duration-300 dark:text-slate-300">{description}</p>;
    $[14] = description;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="absolute bottom-0 left-0 h-1 w-full overflow-hidden bg-transparent"><div className="h-full w-0 bg-gradient-to-r from-[#8939be] via-[#2578f5] to-[#35d5ff] transition-all duration-[1200ms] ease-out group-hover:w-full" /></div>;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t2 || $[18] !== t3 || $[19] !== t4 || $[20] !== t6 || $[21] !== t7 || $[22] !== t8 || $[23] !== t9) {
    t11 = <motion.div initial={t2} whileInView={t3} animate={t4} viewport={t5} transition={t6} className="group relative overflow-hidden rounded-lg border border-[#d8e8ff] bg-white px-6 py-10 text-center shadow-[0_15px_40px_rgba(30,60,120,0.08)] transition-shadow duration-500 hover:shadow-xl dark:border-slate-700 dark:bg-slate-900 dark:shadow-[0_15px_40px_rgba(0,0,0,0.25)]">{t7}{t8}{t9}{t10}</motion.div>;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  return t11;
}